"use strict";

require('./CompanyUserService.js');
require('../groups/CompanyGroupUserService.js');
require('../form-app-submit-group/FormAppSubmitGroupUserService.js');

function UserTypeaheadDirective(
  CompanyUserService,
  CompanyGroupUserService,
  growl,
  $stateParams,
  FormAppSubmitGroupUserService,
  $translate) {
  return {
    restrict: "EA",
    templateUrl: "partials/company/users/userTypeahead.tpl.html",
    scope: {
      members:        "=uCurrent",
      placeholder:    "=uPlaceholder",
      target:         "=uTarget",
      formAppSubmit:   "=formAppSubmit"

    },
    link: function($scope) {
      $scope.addMember = function(user) {
        if (!$scope.formAppSubmit) {
          CompanyGroupUserService.save({companyId: $stateParams.companyId, groupId: $scope.target}, user, function() {
            $scope.members.push(user);
            growl.addSuccessMessage($translate.instant('customer-portals.add-member-success'));
            $scope.addedUser = '';
          }, function() {
            growl.addErrorMessage($translate.instant('customer-portals.add-member-failure'));
          });
        } else {
          FormAppSubmitGroupUserService.save({companyId: $stateParams.companyId, groupId: $scope.target}, user, function() {
            $scope.members.push(user);
            growl.addSuccessMessage($translate.instant('customer-portals.add-member-success'));
            $scope.addedUser = '';
          }, function() {
            growl.addErrorMessage($translate.instant('customer-portals.add-member-failure'));
          });
        }
        
      };

      $scope.queryUsers = function(text) {
        return CompanyUserService.query({
          companyId: $stateParams.companyId,
          q: text,
          limit: 10
        }).$promise.then(function(u){
          return u.filter(function(u){
            return !$scope.members.some(function(member){
              return member.id === u.id;
            });
          });
        });
      };
    }
  };
}

angular.module("dokiv")
  .directive("uTypeahead", [
    'CompanyUserService',
    'CompanyGroupUserService',
    'growl',
    '$stateParams',
    'FormAppSubmitGroupUserService',
    '$translate',
    UserTypeaheadDirective
  ]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/users/CompanyUsersTypeahead.js
// module id = 46
// module chunks = 0